import { BarChart, HeatmapChart, LineChart } from 'echarts/charts';
import {
  CalendarComponent,
  DatasetComponent,
  GridComponent,
  LegendComponent,
  PolarComponent,
  TooltipComponent,
  VisualMapComponent,
} from 'echarts/components';
import * as echarts from 'echarts/core';
import { SVGRenderer } from 'echarts/renderers';

echarts.use([
  HeatmapChart,
  LineChart,
  SVGRenderer,
  BarChart,
  TooltipComponent,
  GridComponent,
  DatasetComponent,
  VisualMapComponent,
  PolarComponent,
  LegendComponent,
  CalendarComponent,
]);

export { echarts };
